import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";

export const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  minHeight: 32,
  padding: 0,
  "&.Mui-expanded": {
    minHeight: 32,
  },
  "& .MuiAccordionSummary-content": {
    margin: "8px 0 8px 10px",
  },
  "& .MuiAccordionSummary-content.Mui-expanded": {
    margin: "8px 0 8px 10px",
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    marginRight: "10px",
  },
}));

export const tableHeaderStyle = {
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: "#f8f9fa",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export const tableHeaderStyleCenter = {
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: "#f8f9fa",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  textAlign: "center",
};

export const tableContentStyle = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export const styledTableScroll = {
  width: "100%",
  maxHeight: "400px",
  overflowX: "hidden",
  overflowY: "auto",
};
